<div class="boxed show-for-m">
  <div class="margin-b-2">
    <app-search-filter></app-search-filter>
  </div>
</div>
<div class="boxed max-height mobil-unboxed">
  <h1 class="margin-b-1">{{ productData.texts.title | i18next }}</h1>
  <div class="grid product-infos">
    <div class="xs-12 m-8 product-properties">
      <div class="headline">{{ "product-detail.details" | i18next }}</div>
      <div class="properties-list">
        <div *ngIf="priceActive" class="list-item">
          <div class="grid align-spaced">
            <div class="xs-6 m-6">
              {{ "product-detail.price" | i18next }}<sup>*</sup>
            </div>
            <div class="xs-6 m-6 text-right property-value">
              {{
                productData.price
                  | currency
                    : collectionsService.currencyCode
                    : currencySymbol
                    : "1.2-2"
                    : "de"
              }}
            </div>
          </div>
        </div>
        <div *ngIf="productData.filters._default.material" class="list-item">
          <div class="grid align-spaced">
            <div class="xs-12 m-6">
              {{ "product-detail.material" | i18next }}
            </div>
            <div class="xs-12 m-6 text-right property-value">
              <ng-container
                *ngFor="let material of productData.filters._default.material"
              >
                {{ materials[material] }}<br />
              </ng-container>
            </div>
          </div>
        </div>
        <div *ngIf="productData.texts.dimensions" class="list-item">
          <div class="grid align-spaced">
            <div class="xs-12 m-6">
              {{ "product-detail.dimensions" | i18next }}
            </div>
            <div class="xs-12 m-6 text-right property-value">
              {{ productData.texts.dimensions | i18next }}
            </div>
          </div>
        </div>
        <div *ngIf="productData.texts.diameter_text" class="list-item">
          <div class="grid align-spaced">
            <div class="xs-12 m-6">
              {{ "product-detail.diameter" | i18next }}
            </div>
            <div class="xs-12 m-6 text-right property-value">
              {{ productData.texts.diameter_text.toString() | i18next }}
            </div>
          </div>
        </div>
        <div *ngIf="productData.texts.volume_text" class="list-item">
          <div class="grid align-spaced">
            <div class="xs-12 m-6">{{ "product-detail.volume" | i18next }}</div>
            <div class="xs-12 m-6 text-right property-value">
              {{ productData.texts.volume_text | i18next }}
            </div>
          </div>
        </div>
        <div *ngIf="productData.texts.weight_text" class="list-item">
          <div class="grid align-spaced">
            <div class="xs-12 m-6">{{ "product-detail.weight" | i18next }}</div>
            <div class="xs-12 m-6 text-right property-value">
              {{ productData.texts.weight_text.toString() | i18next }}
            </div>
          </div>
        </div>
        <div
          *ngIf="productData.dishwasher_safe !== undefined"
          class="list-item"
        >
          <div class="grid align-spaced">
            <div class="xs-12 m-6">
              {{ "product-detail.dishwasher_safe" | i18next }}
            </div>
            <div
              class="xs-12 m-6 text-right property-value"
              *ngIf="productData.dishwasher_safe"
            >
              {{ "product-detail.yes" | i18next }}
            </div>
            <div
              class="xs-12 m-6 text-right property-value"
              *ngIf="!productData.dishwasher_safe"
            >
              {{ "product-detail.no" | i18next }}
            </div>
          </div>
        </div>
        <div *ngIf="productData.microwave_safe !== undefined" class="list-item">
          <div class="grid align-spaced">
            <div class="xs-12 m-6">
              {{ "product-detail.microwave_safe" | i18next }}
            </div>
            <div
              class="xs-12 m-6 text-right property-value"
              *ngIf="productData.microwave_safe"
            >
              {{ "product-detail.yes" | i18next }}
            </div>
            <div
              class="xs-12 m-6 text-right property-value"
              *ngIf="!productData.microwave_safe"
            >
              {{ "product-detail.no" | i18next }}
            </div>
          </div>
        </div>
        <div *ngIf="productData.packaging_unit" class="list-item">
          <div class="grid align-spaced">
            <div class="xs-12 m-6">
              {{ "product-detail.packaging_unit" | i18next }}
            </div>
            <div class="xs-12 m-6 text-right property-value">
              {{ productData.packaging_unit }}
            </div>
          </div>
        </div>
        <div *ngIf="productData.publication_year" class="list-item">
          <div class="grid align-spaced">
            <div class="xs-12 m-6">
              {{ "product-detail.publication_year" | i18next }}
            </div>
            <div class="xs-12 m-6 text-right property-value">
              {{ productData.publication_year }}
            </div>
          </div>
        </div>
        <div *ngIf="productData.expiration_date" class="list-item">
          <div class="grid align-spaced">
            <div class="xs-12 m-6">
              {{ "product-detail.expiration_date" | i18next }}
            </div>
            <div class="xs-12 m-6 text-right property-value">
              {{ productData.expiration_date }}
            </div>
          </div>
        </div>
        <div *ngIf="productData.sku" class="list-item">
          <div class="grid align-spaced">
            <div class="xs-12 m-6">
              {{ "product-detail.item-number" | i18next }}
            </div>
            <div class="xs-12 m-6 text-right property-value">
              {{ productData.sku | skuFormatter }}
            </div>
          </div>
        </div>
        <div class="list-item no-border">
          <div class="grid align-spaced">
            <div class="xs-12 m-6">GTIN</div>
            <div class="xs-12 m-6 text-right">
              <ngx-barcode6
                [bc-display-value]="true"
                [bc-height]="66"
                [bc-margin-right]="1"
                [bc-margin-top]="1"
                [bc-value]="productData.gtin.toString()"
              ></ngx-barcode6>
            </div>
          </div>
        </div>
      </div>
      <small *ngIf="priceActive" class="price-info-txt">{{
        priceListTxt | i18next
      }}</small>
    </div>
    <div class="xs-12 m-4 product-img-section text-center">
      <button type="button" (click)="openLightbox()">
        <img
          [ngClass]="{ freestanding: freestanding }"
          class="product-image"
          src="{{ productData.images.freestanding_1 | image }}"
          loading="lazy"
          width="250"
        />
      </button>
      <h3>{{ productData.texts.headline | i18next }}</h3>
      <p [innerHTML]="productData.texts.description | i18next"></p>
    </div>
  </div>
  <div class="boxed mobil-boxed margin-b-3">
    <div class="hide-for-m">
      <h1>{{ "experience-the-product.experience-product" | i18next }}</h1>
      <div class="grid squares margin-b-3">
        <div *ngIf="productData.images.freestanding_1" class="xs-6 m-3 item">
          <button
            type="button"
            (click)="
              openLightboxForExperience(
                $event,
                productData.images.freestanding_1
              )
            "
          >
            <img
              src="{{ productData.images.freestanding_1 | image }}"
              loading="lazy"
            />
          </button>
        </div>
        <div *ngIf="productData.images.freestanding_2" class="xs-6 m-3 item">
          <button
            type="button"
            (click)="
              openLightboxForExperience(
                $event,
                productData.images.freestanding_2
              )
            "
          >
            <img
              src="{{ productData.images.freestanding_2 | image }}"
              loading="lazy"
            />
          </button>
        </div>
        <div *ngIf="productData.images.freestanding_3" class="xs-6 m-3 item">
          <button
            type="button"
            (click)="
              openLightboxForExperience(
                $event,
                productData.images.freestanding_3
              )
            "
          >
            <img
              src="{{ productData.images.freestanding_3 | image }}"
              loading="lazy"
            />
          </button>
        </div>
        <div
          *ngIf="productData.images.freestanding_mood_1"
          class="xs-6 m-3 item"
        >
          <button
            type="button"
            (click)="
              openLightboxForExperience(
                $event,
                productData.images.freestanding_mood_1
              )
            "
          >
            <img
              src="{{ productData.images.freestanding_mood_1 | image }}"
              loading="lazy"
            />
          </button>
        </div>
        <div
          *ngIf="productData.images.freestanding_mood_2"
          class="xs-6 m-3 item"
        >
          <button
            type="button"
            (click)="
              openLightboxForExperience(
                $event,
                productData.images.freestanding_mood_2
              )
            "
          >
            <img
              src="{{ productData.images.freestanding_mood_2 | image }}"
              loading="lazy"
            />
          </button>
        </div>
        <div
          *ngIf="productData.images.freestanding_mood_3"
          class="xs-6 m-3 item"
        >
          <button
            type="button"
            (click)="
              openLightboxForExperience(
                $event,
                productData.images.freestanding_mood_3
              )
            "
          >
            <img
              src="{{ productData.images.freestanding_mood_3 | image }}"
              loading="lazy"
            />
          </button>
        </div>
        <div *ngIf="productData.images.milieu_1" class="xs-6 m-3 item">
          <button
            type="button"
            (click)="
              openLightboxForExperience($event, productData.images.milieu_1)
            "
          >
            <img
              src="{{ productData.images.milieu_1 | image }}"
              loading="lazy"
            />
          </button>
        </div>
        <div *ngIf="productData.images.usp_design_1" class="xs-6 m-3 item">
          <button
            type="button"
            (click)="
              openLightboxForExperience($event, productData.images.usp_design_1)
            "
          >
            <img
              src="{{ productData.images.usp_design_1 | image }}"
              loading="lazy"
            />
          </button>
        </div>
        <div *ngIf="productData.images.usp_function_1" class="xs-6 m-3 item">
          <button
            type="button"
            (click)="
              openLightboxForExperience(
                $event,
                productData.images.usp_function_1
              )
            "
          >
            <img
              src="{{ productData.images.usp_function_1 | image }}"
              loading="lazy"
            />
          </button>
        </div>
        <div *ngIf="productData.images.usp_function_2" class="xs-6 m-3 item">
          <button
            type="button"
            (click)="
              openLightboxForExperience(
                $event,
                productData.images.usp_function_2
              )
            "
          >
            <img
              src="{{ productData.images.usp_function_2 | image }}"
              loading="lazy"
            />
          </button>
        </div>
        <div *ngIf="productData.images.usp_function_3" class="xs-6 m-3 item">
          <button
            type="button"
            (click)="
              openLightboxForExperience(
                $event,
                productData.images.usp_function_3
              )
            "
          >
            <img
              src="{{ productData.images.usp_function_3 | image }}"
              loading="lazy"
            />
          </button>
        </div>
        <div *ngIf="productData.images.in_use_1" class="xs-6 m-3 item">
          <button
            type="button"
            (click)="
              openLightboxForExperience($event, productData.images.in_use_1)
            "
          >
            <img
              src="{{ productData.images.in_use_1 | image }}"
              loading="lazy"
            />
          </button>
        </div>
        <div *ngIf="productData.images.usp_design_2" class="xs-6 m-3 item">
          <button
            type="button"
            (click)="
              openLightboxForExperience($event, productData.images.usp_design_2)
            "
          >
            <img
              src="{{ productData.images.usp_design_2 | image }}"
              loading="lazy"
            />
          </button>
        </div>
        <div *ngIf="productData.images.in_use_2" class="xs-6 m-3 item">
          <button
            type="button"
            (click)="
              openLightboxForExperience($event, productData.images.in_use_2)
            "
          >
            <img
              src="{{ productData.images.in_use_2 | image }}"
              loading="lazy"
            />
          </button>
        </div>
        <div *ngIf="productData.images.milieu_2" class="xs-6 m-3 item">
          <button
            type="button"
            (click)="
              openLightboxForExperience($event, productData.images.milieu_2)
            "
          >
            <img
              src="{{ productData.images.milieu_2 | image }}"
              loading="lazy"
            />
          </button>
        </div>
        <div *ngIf="productData.images.collection" class="xs-6 m-3 item">
          <button
            type="button"
            (click)="
              openLightboxForExperience($event, productData.images.collection)
            "
          >
            <img
              src="{{ productData.images.collection | image }}"
              loading="lazy"
            />
          </button>
        </div>
        <div *ngIf="productData.images.packaging" class="xs-6 m-3 item">
          <button
            type="button"
            (click)="
              openLightboxForExperience($event, productData.images.packaging)
            "
          >
            <img
              src="{{ productData.images.packaging | image }}"
              loading="lazy"
            />
          </button>
        </div>
        <div *ngIf="productData.images.logo" class="xs-6 m-3 item">
          <button
            type="button"
            (click)="openLightboxForExperience($event, productData.images.logo)"
          >
            <img src="{{ productData.images.logo | image }}" loading="lazy" />
          </button>
        </div>
        <div *ngIf="productData.images.gift" class="xs-6 m-3 item">
          <button
            type="button"
            (click)="openLightboxForExperience($event, productData.images.gift)"
          >
            <img src="{{ productData.images.gift | image }}" loading="lazy" />
          </button>
        </div>
      </div>
    </div>
    <app-matching-products
      *ngIf="crossSelling.length > 0"
      [crossSellingProducts]="crossSelling"
    ></app-matching-products>
  </div>
</div>
<app-experience-the-product class="moreImages"></app-experience-the-product>
<div class="sticky bottom">
  <app-add-to-cart [product]="productData"></app-add-to-cart>
</div>
